<template>
  <el-card>
    <span class="title">课程文件</span>
  </el-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
}
</style>
